import { css, styled } from 'styled-components';

import { colors, transition } from 'theme/theme';

export const CheckboxLabel = styled.label<{
  $hasError: boolean;
  $hasText: boolean;
}>`
  line-height: ${(props) => (props.$hasText ? 1.4 : null)};
  user-select: none;
  cursor: pointer;
  position: relative;
  display: inline-flex;
  align-items: start;
  gap: 12px;
  border-radius: 8px;
  ${(props) =>
    props.$hasError &&
    css`
      border: solid 1px ${colors.alertRed};
      box-shadow: 0 0 0 1px ${colors.alertRed};
      padding-right: 15px;
      padding-left: 15px;
    `};
`;

export const CheckboxInput = styled.input<{ $large: boolean }>`
  appearance: none;
  margin: 0;

  position: relative;
  width: ${(props) => (props.$large ? 24 : 16)}px;
  height: ${(props) => (props.$large ? 24 : 16)}px;
  cursor: pointer;

  background: ${colors.inputGrey};
  box-shadow: 0 0 0 1px rgb(0 0 0 / 20%) inset;

  &:disabled {
    background: ${colors.selectionGrey};
    box-shadow: 0 0 0 1px rgb(0 0 0 / 0%) inset;
  }

  &:checked {
    background: ${colors.brandBlue};
    background-clip: content-box;
    box-shadow: 0 0 0 1px rgb(0 0 0 / 0%) inset;

    &::after {
      opacity: 1;
    }
  }

  &:not(:checked)::after {
    opacity: 0;
  }

  &::after {
    content: '';
    transition: ${transition} ease;
    transition-property: opacity;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    height: 90%;

    /* this is the inlined svg for simple-check.svg with fill='white' */
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='white' viewBox='0 0 24 24'%3E%3Cpath fill-rule='evenodd' d='M19.707 7.293a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L10 15.586l8.293-8.293a1 1 0 0 1 1.414 0Z' clip-rule='evenodd'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition: all ${transition};
  border-radius: 2px;
`;
